import apiClient from './client';
import { CreateAuthorSchema, UpdateAuthorSchema } from 'shared-schemas';

export const authorsApi = {
  list: async (params = {}) => {
    const response = await apiClient.get('/api/authors', { params });
    return response.data;
  },
  
  get: async (id) => {
    const response = await apiClient.get(`/api/authors/${id}`);
    return response.data;
  },
  
  getByAlias: async (alias) => {
    const response = await apiClient.get(`/api/authors/alias/${alias}`);
    return response.data;
  },
  
  search: async (query, limit = 10) => {
    const response = await apiClient.get('/api/authors/search', { 
      params: { q: query, limit: limit.toString() } 
    });
    return response.data;
  },
  
  create: async (authorData) => {
    // For create operations, remove empty string fields entirely
    const cleanData = Object.fromEntries(
      Object.entries(authorData).filter(([, value]) => value !== '')
    );
    const validated = CreateAuthorSchema.parse(cleanData);
    const response = await apiClient.post('/api/authors', validated);
    return response.data;
  },
  
  update: async (id, authorData) => {
    // For update operations, convert empty strings to null to properly clear fields in Ampt Data
    const cleanData = Object.fromEntries(
      Object.entries(authorData).map(([key, value]) => {
        // Convert empty strings to null so Ampt Data knows to clear the field
        return [key, value === '' ? null : value];
      })
    );
    
    const validated = UpdateAuthorSchema.parse(cleanData);
    const response = await apiClient.patch(`/api/authors/${id}`, validated);
    return response.data;
  },
  
  delete: async (id) => {
    await apiClient.delete(`/api/authors/${id}`);
  },
};
